// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab_container__2LOy7"};